// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  font-size: 25px;
  margin-bottom: 5px;
  text-align: center;
}

.subHeading {
  text-align: center;
  color: #8a8a8a;
}

.shadow {
  width: 160px;
}

.fontweight600 {
  font-weight: 600;
}

.header2 .block-limiter {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
}

.header2 .brandhotelselector {
  margin-top: 5px;
}

.bellContainer {
  position: relative;
  width: 50px;
}

.floatRight {
  float: right;
}

.marginBottom20 {
  margin-bottom: 20px;
}

.calender-selection {
  margin-top: 5px;
}

.calender-selection .control-select-men {
  display: inline-block;
  float: left;
}

.calender-selection .control-select-filter-men {
  display: inline-block;
  float: left;
}

.displayInline {
  display: inline !important;
}

.stdcontainer .block-limiter {
  padding: 0 16px 16px 16px !important;
}

.fullWidthSelect {
  width: 100% !important;
}

.shadow {
  width: 160px;
}

.noShadow {
  box-shadow: none;
}

.tagsContainer {
  float: left;
}

.iconsContainer {
  float: left;
}

.iconsContainer svg {
  height: 20px !important;
  width: 20px !important;
  margin-right: 10px;
}

.stdIconContainer {
  margin-top: 10px;
}

.tagsContainer .tags-tag {
  background-color: #FFF;
  border: 1px solid #d1dbec;
}

.stdIconContainer svg {
  margin-right: 15px;
}

.tabContainer .tabContent {
  display: none;
}

.tabContainer .active {
  display: block;
}

.tabs {
  width: 100%;
}

.tabs .tabs-ul {
  list-style: none;
  padding-bottom: 12px;
  margin-bottom: 0px;
  display: inline-block;
  border-bottom: 1px solid #F1F1F1;
  overflow-x: auto;
  overflow-y: hidden;
  display: -webkit-box;
  display: -moz-box;
  white-space: nowrap;
}

.tabs .tabs-ul li {
  display: inline;
  margin-right: 10px;
  color: #919191;
  font-size: 18px;
  font-weight: 400;
  padding-bottom: 10px;
}

.tabs .tabs-ul li.activeTab {
  border-bottom: 3px solid #58c3bb;
  color: #000;
  font-weight: 600;
}

.subTabs {
  width: 100%;
  white-space: nowrap;
  overflow-x: auto;
}

.subTabs .subTabs-ul {
  list-style: none;
  padding-bottom: 20px;
  margin-bottom: 10px;
  display: inline-block;
  border-bottom: none;
  overflow-x: auto;
  overflow-y: hidden;
  display: -webkit-box;
  display: -moz-box;
  white-space: nowrap;
}

.subTabs .subTabs-ul li {
  display: inline;
  margin-right: 10px;
  color: #E1E1E1;
  font-size: 18px;
  font-weight: 400;
  padding-bottom: 10px;
  border-bottom: 1px solid #E1E1E1;
}

.tabs .tabs-ul li.activeSubTab {
  color: #58c3bb;
  font-weight: 600;
}

.subTabContainer {
  overflow-x: hidden;
  white-space: normal;
  min-height: 400px;
}

.subTabContainer .tabContent {
  display: none;
  padding: 10px;
}

.subTabContainer .active {
  display: block;
}

.tagsContainer .tags-tag {
  background-color: #fff;
  border: 1px solid #d1dbec;
  padding: 0px;
  font-size: 14px;
}

.submitOverlay .button {
  width: 100%;
}

.submitOverlay > .primary {
  width: 100%;
}

.submitOverlay {
  padding: 20px;
  margin: 5px;
  border-radius: 10px;
  background: white;
  padding-top: 60px;
  padding-bottom: 60px;
}

.button.layout-link.intent-discrete {
  color: #071C3E;
  text-decoration: underline;
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
}

.box-spacing,
.search-wrapper {
  display: flex;
  justify-content: space-between;
}

.assessed-wrapper {
  margin: 16px 0;
  width: 100%;
  box-sizing: border-box;
}
.assessed-wrapper [data-testid=search-box] {
  width: 100%;
  box-sizing: border-box;
}

.edit-self-assessment-date-picker {
  width: 100%;
  box-sizing: border-box;
}
.edit-self-assessment-date-picker > div {
  display: block;
  width: 100%;
  justify-content: flex-start;
}
.edit-self-assessment-date-picker .react-datepicker-wrapper,
.edit-self-assessment-date-picker .react-datepicker__input-container {
  display: block;
  width: 100%;
}
.edit-self-assessment-date-picker .myaudit-filter-date-picker {
  width: 100%;
  box-sizing: border-box;
}

.assessed-wrapper .control-input {
  height: 30px;
  border-radius: 78px;
}

.search-wrapper {
  align-items: center;
  -moz-column-gap: 5px;
  column-gap: 5px;
}

.existing-assessed-wrapper {
  display: flex;
  -moz-column-gap: 10px;
  column-gap: 10px;
  flex-wrap: wrap;
  gap: 10px;
}

.standard-attachment-drawer [data-rsbs-overlay] {
  max-height: calc(100dvh - 120px);
  border-radius: 16px 16px 0 0;
}

.h-device {
  height: 100dvh;
}

.ReactCrop__child-wrapper > img,
.ReactCrop__child-wrapper > video {
  -o-object-fit: contain;
  object-fit: contain;
}

.react-crop .backOverlay {
  margin: 110px 8px !important;
  max-height: calc(100vh - 145px) !important;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ReactCrop {
  max-width: 100%;
  display: flex !important;
  justify-content: center !important;
}

.ReactCrop__child-wrapper {
  max-height: calc(100dvh - 420px) !important;
}

.ReactCrop__child-wrapper::after {
  display: block;
  padding-bottom: 100%;
}

.justify-image-center {
  display: flex;
  justify-content: center;
  max-width: 100%;
}

.overflow-y-scroll {
  overflow-y: scroll;
}

.iconsContainer span:last-child svg path {
  stroke: rgb(145, 145, 145);
}

.light-stroke path {
  stroke: #919191;
}

.no-button button {
  display: none;
}`, "",{"version":3,"sources":["webpack://./styles.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,kBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,cAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,qBAAA;EACA,WAAA;AACJ;;AAEA;EACI,qBAAA;EACA,WAAA;AACJ;;AAEA;EACI,0BAAA;AACJ;;AAEA;EACI,oCAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,uBAAA;EACA,sBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,sBAAA;EACA,yBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,gCAAA;EACA,WAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,mBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gCAAA;AACJ;;AAEA;EACI,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,aAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,sBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;AAAJ;;AAGA;EACI,cAAA;EACA,0BAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAAJ;;AAGA;;EAEI,aAAA;EACA,8BAAA;AAAJ;;AAGA;EACI,cAAA;EACA,WAAA;EACA,sBAAA;AAAJ;AAEI;EACI,WAAA;EACA,sBAAA;AAAR;;AAIA;EACI,WAAA;EACA,sBAAA;AADJ;AAGI;EACI,cAAA;EACA,WAAA;EACA,2BAAA;AADR;AAII;;EAEI,cAAA;EACA,WAAA;AAFR;AAKI;EACI,WAAA;EACA,sBAAA;AAHR;;AAOA;EACI,YAAA;EACA,mBAAA;AAJJ;;AAOA;EACI,mBAAA;EACA,oBAAA;EAAA,eAAA;AAJJ;;AAOA;EACI,aAAA;EACA,qBAAA;EAAA,gBAAA;EACA,eAAA;EACA,SAAA;AAJJ;;AAOA;EACI,gCAAA;EACA,4BAAA;AAJJ;;AAOA;EACI,cAAA;AAJJ;;AAOA;;EAEI,sBAAA;EAAA,mBAAA;AAJJ;;AAOA;EACI,4BAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAJJ;;AAOA;EACI,eAAA;EACA,wBAAA;EACA,kCAAA;AAJJ;;AAOA;EACI,2CAAA;AAJJ;;AAOA;EACI,cAAA;EACA,oBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,uBAAA;EACA,eAAA;AAJJ;;AAOA;EACI,kBAAA;AAJJ;;AAQI;EACI,0BAAA;AALR;;AASA;EACI,eAAA;AANJ;;AASA;EACI,aAAA;AANJ","sourcesContent":["h1 {\n  font-size: 25px;\n  margin-bottom: 5px;\n  text-align: center;\n}\n\n.subHeading {\n  text-align: center;\n  color: #8a8a8a;\n}\n\n.shadow {\n  width: 160px;\n}\n\n.fontweight600 {\n  font-weight: 600;\n}\n\n.header2 .block-limiter {\n  padding-left: 0px;\n  padding-right: 0px;\n  padding-bottom: 0px;\n}\n\n.header2 .brandhotelselector {\n  margin-top: 5px;\n}\n\n.bellContainer {\n  position: relative;\n  width: 50px;\n}\n\n.floatRight {\n  float: right;\n}\n\n.marginBottom20 {\n  margin-bottom: 20px;\n}\n\n.calender-selection {\n  margin-top: 5px;\n}\n\n.calender-selection .control-select-men {\n  display: inline-block;\n  float: left;\n}\n\n.calender-selection .control-select-filter-men {\n  display: inline-block;\n  float: left;\n}\n\n.displayInline {\n  display: inline !important;\n}\n\n.stdcontainer .block-limiter {\n  padding: 0 16px 16px 16px !important;\n}\n\n.fullWidthSelect {\n  width: 100% !important;\n}\n\n.shadow {\n  width: 160px;\n}\n\n.noShadow {\n  box-shadow: none;\n}\n\n.tagsContainer {\n  float: left;\n}\n\n.iconsContainer {\n  float: left;\n}\n\n.iconsContainer svg {\n  height: 20px !important;\n  width: 20px !important;\n  margin-right: 10px;\n}\n\n.stdIconContainer {\n  margin-top: 10px;\n}\n\n.tagsContainer .tags-tag {\n  background-color: #FFF;\n  border: 1px solid #d1dbec;\n}\n\n.stdIconContainer svg {\n  margin-right: 15px;\n}\n\n.tabContainer .tabContent {\n  display: none;\n}\n\n.tabContainer .active {\n  display: block;\n}\n\n.tabs {\n  width: 100%;\n}\n\n.tabs .tabs-ul {\n  list-style: none;\n  padding-bottom: 12px;\n  margin-bottom: 0px;\n  display: inline-block;\n  border-bottom: 1px solid #F1F1F1;\n  overflow-x: auto;\n  overflow-y: hidden;\n  display: -webkit-box;\n  display: -moz-box;\n  white-space: nowrap;\n}\n\n.tabs .tabs-ul li {\n  display: inline;\n  margin-right: 10px;\n  color: #919191;\n  font-size: 18px;\n  font-weight: 400;\n  padding-bottom: 10px;\n}\n\n.tabs .tabs-ul li.activeTab {\n  border-bottom: 3px solid #58c3bb;\n  color: #000;\n  font-weight: 600;\n}\n\n.subTabs {\n  width: 100%;\n  white-space: nowrap;\n  overflow-x: auto;\n}\n\n.subTabs .subTabs-ul {\n  list-style: none;\n  padding-bottom: 20px;\n  margin-bottom: 10px;\n  display: inline-block;\n  border-bottom: none;\n  overflow-x: auto;\n  overflow-y: hidden;\n  display: -webkit-box;\n  display: -moz-box;\n  white-space: nowrap;\n}\n\n.subTabs .subTabs-ul li {\n  display: inline;\n  margin-right: 10px;\n  color: #E1E1E1;\n  font-size: 18px;\n  font-weight: 400;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #E1E1E1;\n}\n\n.tabs .tabs-ul li.activeSubTab {\n  color: #58c3bb;\n  font-weight: 600;\n}\n\n.subTabContainer {\n  overflow-x: hidden;\n  white-space: normal;\n  min-height: 400px;\n}\n\n.subTabContainer .tabContent {\n  display: none;\n  padding: 10px;\n}\n\n.subTabContainer .active {\n  display: block;\n}\n\n.tagsContainer .tags-tag {\n  background-color: #fff;\n  border: 1px solid #d1dbec;\n  padding: 0px;\n  font-size: 14px;\n}\n\n.submitOverlay .button {\n  width: 100%;\n}\n\n.submitOverlay > .primary {\n  width: 100%;\n}\n\n.submitOverlay {\n  padding: 20px;\n  margin: 5px;\n  border-radius: 10px;\n  background: white;\n  padding-top: 60px;\n  padding-bottom: 60px;\n}\n\n.button.layout-link.intent-discrete {\n  color: #071C3E;\n  text-decoration: underline;\n  font-family: \"Source Sans Pro\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n}\n\n.box-spacing,\n.search-wrapper {\n  display: flex;\n  justify-content: space-between;\n}\n\n.assessed-wrapper {\n  margin: 16px 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n.assessed-wrapper [data-testid=search-box] {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.edit-self-assessment-date-picker {\n  width: 100%;\n  box-sizing: border-box;\n}\n.edit-self-assessment-date-picker > div {\n  display: block;\n  width: 100%;\n  justify-content: flex-start;\n}\n.edit-self-assessment-date-picker .react-datepicker-wrapper,\n.edit-self-assessment-date-picker .react-datepicker__input-container {\n  display: block;\n  width: 100%;\n}\n.edit-self-assessment-date-picker .myaudit-filter-date-picker {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.assessed-wrapper .control-input {\n  height: 30px;\n  border-radius: 78px;\n}\n\n.search-wrapper {\n  align-items: center;\n  column-gap: 5px;\n}\n\n.existing-assessed-wrapper {\n  display: flex;\n  column-gap: 10px;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.standard-attachment-drawer [data-rsbs-overlay] {\n  max-height: calc(100dvh - 120px);\n  border-radius: 16px 16px 0 0;\n}\n\n.h-device {\n  height: 100dvh;\n}\n\n.ReactCrop__child-wrapper > img,\n.ReactCrop__child-wrapper > video {\n  object-fit: contain;\n}\n\n.react-crop .backOverlay {\n  margin: 110px 8px !important;\n  max-height: calc(100vh - 145px) !important;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.ReactCrop {\n  max-width: 100%;\n  display: flex !important;\n  justify-content: center !important;\n}\n\n.ReactCrop__child-wrapper {\n  max-height: calc(100dvh - 420px) !important;\n}\n\n.ReactCrop__child-wrapper::after {\n  display: block;\n  padding-bottom: 100%;\n}\n\n.justify-image-center {\n  display: flex;\n  justify-content: center;\n  max-width: 100%;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll;\n}\n\n.iconsContainer span:last-child svg path {\n  stroke: rgb(145, 145, 145);\n}\n\n.light-stroke path {\n  stroke: #919191;\n}\n\n.no-button button {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
